module.exports = { "default": require("core-js/library/fn/set-immediate"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/set-immediate.js
// module id = 347
// module chunks = 2